import { Classes } from '@pinpointhq/thumbtack';
import { delay } from 'lodash';
import * as SmoothScroll from 'smooth-scroll';

export function scrollToElement(element: Document | Element, offset = 50) {
  const scrollingClass = 'smooth-scrolling';
  const durationMax = 500;
  document.body.classList.add(scrollingClass);
  delay(() => {
    document.body.classList.remove(scrollingClass);
  }, durationMax);
  const scroll = new SmoothScroll();
  const options = {
    clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
    durationMax, // Integer. The maximum amount of time the scroll animation should take
    durationMin: 200, // Integer. The minimum amount of time the scroll animation should take
    easing: 'easeInOutCubic', // Easing pattern to use
    emitEvents: false, // Emit custom events
    offset, // Integer or Function returning an integer.
    popstate: false, // Animate scrolling with the forward/backward browser buttons (requires updateURL to be true)
    speed: 500, // Integer. Amount of time in milliseconds it should take to scroll 1000px
    speedAsDuration: false, // If true, use speed as the total duration of the scroll animation
    updateURL: true, // Update the URL on scroll
  };
  scroll.animateScroll(element, null, options);
}

export function scrollToId(id: string, offset = 50) {
  return scrollToElement(document.getElementById(id), offset);
}

// NOTE: If we want to not tie things to Thumbtack, use the below line instead.
// const formFeedbackTextClass = 'bp3-form-feedback-text';
const formFeedbackTextClass = Classes.FORM_FEEDBACK_TEXT;

export function scrollToFirstError() {
  const formFeedbackElements = document.getElementsByClassName(formFeedbackTextClass);
  // If there are no form feedback elements, we don't need to scroll
  //
  if (!formFeedbackElements.length) return;

  const target = formFeedbackElements[0];
  const formGroup = target.closest('.bp3-form-group');

  if (!formGroup || !formGroup.parentElement) return;

  // We actually want to scroll the parent element of the form group of the target element (the target element being the actual error message).
  //
  const scrollTarget = formGroup.parentElement;

  // Create a new observer inside the function
  // The observer will check if the form group is visible in the viewport and if it is, it will nudge the page up by 120px
  // to account for the fixed header on our pages.
  //
  const observer = new IntersectionObserver(
    (entries, obs) => {
      if (entries[0].isIntersecting) {
        // Nudge the scroll by -120px after it's visible
        window.scrollBy({
          top: -120,
          behavior: 'smooth',
        });
        obs.disconnect();
      }
    },
    {
      threshold: 1.0, // Trigger when fully visible
    },
  );

  const drawerElements = document.getElementsByClassName('bp3-drawer');
  // We only need to nudge the scroll if the form we are dealing with is not inside a drawer or other popover element.
  //
  if (drawerElements.length < 1) {
    observer.observe(formGroup);
  }

  // Scroll to the form group container
  //
  scrollTarget.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest',
  });
}
